import React from "react";
import { AppId, FCX, ProductLogo, sanitize, usePlatformContext } from "@datassential/platform-ui-lib";
import cn from "classnames";
import Widget from "@components/Widget/Widget";
import PublicationCard, { PublicationCardTooltip } from "@components/PublicationCard/PublicationCard";
import { useSocialMediaPublications } from "@apiHooks/useSocialMediaPublications";
import './PeopleSocialPublication.scss';

const REPORT_PRO_TAG_ID = 136

const PeopleSocialPublication: FCX = ({
  className,
  testId,
  style,
}) => {
    const {
        data: publications,
        isLoading,
    } = useSocialMediaPublications();

    const {
        userInfo: {
            products,
            reportProDetailsUrl,
        },
    } = usePlatformContext();
    const productRP = products[AppId.ReportPro];
    const detailsPath = process.env.REACT_APP_RP_ITEM_LINK ?? reportProDetailsUrl;

    const publication = publications[0];

    return (
        <Widget
            className={cn(
                "PeopleSocialPublication",
                className,
                isLoading && "PeopleSocialPublication--loading"
            )}
            style={style}
            headerContent={(
                <div className="PeopleSocialPublication__header">
                    <div className="PeopleSocialPublication__header-title">
                        READ ABOUT IT:
                    </div>
                    {!isLoading && (
                        <a
                            className="PeopleSocialPublication__view-more appears"
                            target="_blank"
                            rel="noreferrer"
                            href={sanitize(`${productRP.url}/?tags=${REPORT_PRO_TAG_ID}`)}
                            data-testid={`buttonMacReportsItemViewMore`}
                        >View all</a>
                    )}
                </div>
            )}
            testId={testId}
        >
            <div
                className={cn("PeopleSocialPublication__content", isLoading && "PeopleSocialPublication__content--loading")}>
                {isLoading && (
                    <div className="TrendingNow__spinner">
                        <ProductLogo appId={AppId.Snap} type="regular"/>
                    </div>
                )}
                {publication && (
                    <React.Fragment>
                        <PublicationCard
                            className="PeopleSocialPublication__card"
                            data={publication}
                            index={0}
                            link={`${productRP.url}${detailsPath}${publication.id}`}
                            tooltipId={`people-publication-${publication.id}`}
                            testIdBase="PeopleSocialPublication"
                        />
                        <PublicationCardTooltip
                            className="PeopleSocialPublication__card-tooltip"
                            data={publication}
                            index={0}
                            tooltipId={`people-publication-${publication.id}`}
                            testIdBase="PeopleSocialPublication"
                        />
                    </React.Fragment>
                )}
            </div>
        </Widget>
    );
};

export default PeopleSocialPublication;
